import styled from '@emotion/styled';
import { CloseIcon } from 'src/assets/icons/CloseIcon';
import { ContentH2, ContentH3 } from '../../../typography/Content.style';

export const PopupWrapper = styled('div', { label: 'PopupWrapper' })`
    margin: 32px 32px 40px 32px;
    position: relative;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    text-align: center;
`;

export const PopupLabel = styled(ContentH2, { label: 'PopupLabel' })`
    margin-bottom: 8px;
`;

export const PopupText = styled(ContentH3, { label: 'PopupText' })`
    margin-bottom: 16px;
`;

export const CloseIconWrapper = styled(CloseIcon, { label: 'CloseIconWrapper' })`
    cursor: pointer;
    flex: 0 0 13px;
    width: 13px;
    position: absolute;
    inset: -15px -15px auto auto;
`;
